import React from 'react';

import Toggle from '../../../../library/toggle/toggle';
import Typography from '../../../../library/typography/typography';
import { SnowflakeRegularIcon } from '../../../../shared/icons/icons';

import {
  useAemContent,
  useTreadwellPreferences
} from '../../../../shared/hooks/hooks';

import {
  AEM_CONTENT_IDS,
  AEM_CONTENT_PAGE_IDS
} from '../../../../shared/constants/cms';

import styles from './winter-toggle.scss';

interface WinterToggleProps {
  onToggle: () => void;
}

function WinterToggle(props: WinterToggleProps) {
  const { onToggle } = props;

  const { treadwellPreferences } = useTreadwellPreferences();

  const { showWinterTires } = treadwellPreferences || {};

  const { aemTooltipsContent } = useAemContent(
    AEM_CONTENT_PAGE_IDS.treadwellPlp
  );

  const toggleCopy = aemTooltipsContent?.[AEM_CONTENT_IDS.toggleCopy];

  return (
    <div className={styles['container']}>
      <Toggle
        ariaLabelledBy="winter-toggle"
        icon={<SnowflakeRegularIcon className={styles[`toggle-icon`]} />}
        isEnabled={Boolean(showWinterTires)}
        label={
          <Typography
            className={`${styles['winter-toggle-title']} ${
              showWinterTires ? styles['winter-toggle-title--checked'] : ''
            }`}
          >
            {toggleCopy?.title || 'Shop Winter Tires'}
          </Typography>
        }
        onToggle={onToggle}
      />
    </div>
  );
}

export default WinterToggle;
